"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8121],{

/***/ 98121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ StyledSwiper; },
/* harmony export */   "_D": function() { return /* binding */ ArticlePageStyledSwiper; },
/* harmony export */   "dv": function() { return /* binding */ ModuleStyledSwiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30719);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25820);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .banner-swiper-prev,\n  .banner-swiper-next {\n    position: absolute;\n    top: 50%;\n    transform: translate(0, -50%);\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}



const CustomizeStyledSwiper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n  .swiper-slide {\n    width: 100%;\n  }\n\n  .banner-swiper-prev, .banner-swiper-next {\n    position: absolute;\n    display: none;\n    background: rgba(256, 256, 256, 0.5);\n    box-shadow: 0 0 0.5rem 0.5rem rgba(0, 0, 0, 0.01);\n    border-radius: 50%;\n    cursor: pointer;\n    z-index: 1;\n\n    ".concat(theme.breakpoints.up("lg"), " {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 48px;\n      height: 48px;\n    }\n\n    > .MuiSvgIcon-root {\n      font-size: 1rem;\n    }\n  }\n  .banner-swiper-prev {\n    left: 24px;\n    padding-left: 8px;\n  }\n  .banner-swiper-next {\n    right: 24px;\n    padding-left: 2px;\n  }\n\n  .banner-pagination {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    position: absolute;\n    bottom: 16px;\n    z-index: 1;\n\n    > .swiper-pagination-bullet {\n      display: block;\n      width: ").concat(theme.spacing(1), ";\n      height: ").concat(theme.spacing(1), ";\n      border-radius: 50%;\n      background-color: ").concat(theme.palette.text.disabled, ";\n      cursor: pointer;\n\n      &.swiper-pagination-bullet-active {\n        width: ").concat(theme.spacing(4), ";\n        border-radius: 2px;\n        background-color: ").concat(theme.palette.primary.mainPlus2, ";\n        opacity: 1;\n      }\n\n      &:not(:first-child) {\n        margin-left: ").concat(theme.spacing(2), ";\n      }\n    }\n  }\n");
});
const ArticlePageStyledSwiper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CustomizeStyledSwiper)(_templateObject1());
const StyledSwiper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CustomizeStyledSwiper)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    &.swiper {\n      min-height: ".concat(_index__WEBPACK_IMPORTED_MODULE_3__/* .minHeight */ .jw, ";\n    }\n\n    .banner-swiper-prev, .banner-swiper-next {\n      position: absolute;\n      bottom: 50%;\n      transform: translate(0, -50%);\n    }\n\n    .banner-pagination {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      position: absolute;\n      bottom: 16px;\n      z-index: 1;\n\n      ").concat(theme.breakpoints.up("lg"), " {\n        display: none;\n      }\n    }\n  }\n");
});
const ModuleStyledSwiper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CustomizeStyledSwiper)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    &.swiper {\n      min-height: ".concat(_index__WEBPACK_IMPORTED_MODULE_3__/* .minHeight */ .jw, ";\n    }\n\n    .banner-swiper-prev, .banner-swiper-next {\n      position: absolute;\n      top: 50%;\n      transform: translate(0, -50%);\n    }\n\n    .banner-pagination {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      position: absolute;\n      bottom: 16px;\n      z-index: 1;\n\n      ").concat(theme.breakpoints.up("lg"), " {\n        display: none;\n      }\n    }\n  }\n");
});



/***/ }),

/***/ 25820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nt": function() { return /* binding */ AdvertisementBanner; },
/* harmony export */   "jw": function() { return /* binding */ minHeight; },
/* harmony export */   "tS": function() { return /* binding */ BannerImg; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24994);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39086);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62097);
/* harmony import */ var utils_hooks_useBannerGA__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(778);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  object-fit: cover;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}









const minHeight = "186px";
const BannerImg = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .Z.img(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    min-height: ".concat(minHeight, ";\n    width: 100%;\n    border-radius: ").concat(theme.spacing(6), ";\n    cursor: pointer;\n  ");
});
const Img = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .Z.img(_templateObject1());
const AdvertisementBanner = (param)=>{
    let { banner , bannerLocation  } = param;
    var _banner_image;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.down("xl"));
    const onBannerClick = async ()=>{
        (0,utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_7__/* .sendBannerClick */ .y)({
            banner,
            bannerLocation
        });
        const { path , isExternalLink  } = await (0,utils_api__WEBPACK_IMPORTED_MODULE_8__/* .genPathByNavData */ .E)(banner.navData);
        if (path) {
            if (isExternalLink) {
                window.open(path, "_blank");
            } else {
                router.push(path);
            }
        }
    };
    (0,utils_hooks_useBannerGA__WEBPACK_IMPORTED_MODULE_4__/* .useBannerGAForNonCarousel */ .w)({
        bannerData: [
            banner
        ],
        bannerLocation,
        isRepeated: false
    });
    (0,utils_hooks_useBannerGA__WEBPACK_IMPORTED_MODULE_4__/* .useBannerGAForNonCarousel */ .w)({
        bannerData: [
            banner
        ],
        bannerLocation,
        isRepeated: true
    });
    if (isMobile) {
        var _banner_imageDouble;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            my: {
                xs: 18,
                lg: 24
            },
            mx: {
                xs: 0,
                md: "5%"
            },
            "data-banner-id": banner === null || banner === void 0 ? void 0 : banner._id,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
                src: banner === null || banner === void 0 ? void 0 : (_banner_imageDouble = banner.imageDouble) === null || _banner_imageDouble === void 0 ? void 0 : _banner_imageDouble.url,
                onClick: onBannerClick,
                id: "advertisement-banner-".concat(banner._id)
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        my: 24,
        "data-banner-id": banner === null || banner === void 0 ? void 0 : banner._id,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
            src: banner === null || banner === void 0 ? void 0 : (_banner_image = banner.image) === null || _banner_image === void 0 ? void 0 : _banner_image.url,
            onClick: onBannerClick,
            id: "advertisement-banner-".concat(banner._id)
        })
    });
};



/***/ }),

/***/ 39086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ genPathByNavData; }
/* harmony export */ });
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8217);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60569);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42766);

const genPathByNavData = async (param)=>{
    let { page , action , param: param1  } = param;
    if (!page) {
        return;
    }
    if (page === "default") {
        return {
            path: "/"
        };
    } else if (page === "none" && action === "openUrl") {
        return {
            path: param1 === null || param1 === void 0 ? void 0 : param1.url,
            isExternalLink: true
        };
    } else if (page === "couponList") {
        let url = "/coupon";
        if (action === "addItem") {
            url += "?acquire=".concat(param1 === null || param1 === void 0 ? void 0 : param1.couponCode);
        } else if (action === "fill") {
            url += "?fill=".concat(param1 === null || param1 === void 0 ? void 0 : param1.couponCode);
        }
        return {
            path: url
        };
    } else if (page === "serviceClassification") {
        let postfix = "";
        if (action === "bookService") {
            postfix = "/booking";
        }
        const [classification] = await (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .getClassification */ .p)(param1 === null || param1 === void 0 ? void 0 : param1.classificationId);
        if (classification) {
            return {
                path: "/service/".concat(classification === null || classification === void 0 ? void 0 : classification.identityCode).concat(postfix)
            };
        }
    } else if (page === "article") {
        const [article, error] = await (0,utils_api__WEBPACK_IMPORTED_MODULE_1__/* .getArticleById */ .V)(param1 === null || param1 === void 0 ? void 0 : param1.articleId);
        if (article && !error) {
            return {
                path: "/article/".concat(article === null || article === void 0 ? void 0 : article.urlId)
            };
        }
    } else if (page === "vender") {
        const [vender, error1] = await (0,utils_api__WEBPACK_IMPORTED_MODULE_2__/* .getVenderById */ .Y)(param1 === null || param1 === void 0 ? void 0 : param1.venderId);
        if (vender && !error1) {
            var _vender_introductionInfo;
            if (!(vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo = vender.introductionInfo) === null || _vender_introductionInfo === void 0 ? void 0 : _vender_introductionInfo.isVisible)) {
                return {
                    path: "/vender?page=1"
                };
            }
            return {
                path: "/vender/".concat(vender === null || vender === void 0 ? void 0 : vender.urlId)
            };
        }
    }
    return {
        path: "/"
    };
};


/***/ }),

/***/ 60569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getArticleById; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const getArticleById = (id)=>{
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsGet */ .UY)("/articles/".concat(id)));
};


/***/ }),

/***/ 8217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ getClassification; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const getClassification = (classificationId)=>{
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsGet */ .UY)("/serviceClassifications/".concat(classificationId)));
};


/***/ }),

/***/ 42766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getVenderById; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const getVenderById = (id)=>{
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsGet */ .UY)("/venders/".concat(id)));
};


/***/ }),

/***/ 24994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ sendBannerClick; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42395);
/* harmony import */ var _GtmAgent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27582);


// Banner 模組的 banner 名稱欄位為 title
const sendBannerClick = (param)=>{
    let { banner , moduleId , bannerLocation , venderName , venderId  } = param;
    if (!banner) {
        throw new Error("Banner is empty. Can not send GTM data");
    }
    _GtmAgent__WEBPACK_IMPORTED_MODULE_0__/* .GtmAgent.directSendToGTM */ .b.directSendToGTM({
        event: _constants__WEBPACK_IMPORTED_MODULE_1__/* .BANNER_CLICK */ .Zd,
        living_bnid: banner === null || banner === void 0 ? void 0 : banner._id
    });
    _GtmAgent__WEBPACK_IMPORTED_MODULE_0__/* .GtmAgent.directSendToGTM */ .b.directSendToGTM({
        event: "living_action",
        living_event_name: "banner_click",
        living_banner_name: (banner === null || banner === void 0 ? void 0 : banner.name) || (banner === null || banner === void 0 ? void 0 : banner.title),
        living_banner_id: banner === null || banner === void 0 ? void 0 : banner._id,
        ...moduleId && {
            living_module_id: moduleId
        },
        ...bannerLocation && {
            living_banner_location: bannerLocation
        },
        ...venderName && {
            living_vender: venderName
        },
        ...venderId && {
            living_vender_id: venderId
        }
    });
};


/***/ }),

/***/ 778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useBannerGAForCarousel; },
  "w": function() { return /* binding */ useBannerGAForNonCarousel; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/hooks/analytics/constants.js
var constants = __webpack_require__(42395);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
;// CONCATENATED MODULE: ./utils/hooks/analytics/GtmAgent/sendBannerImpression.js


// Banner 模組的 banner 名稱欄位為 title
// Banner 首次曝光
const sendBannerImpressionUnique = (param)=>{
    let { banner , moduleId , bannerLocation , venderName , venderId  } = param;
    if (!banner) {
        throw new Error("Banner is empty. Can not send GTM impression data");
    }
    GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
        event: "living_action",
        living_event_name: constants/* BANNER_IMPRESSION_UNIQUE */.Qn,
        living_banner_name: (banner === null || banner === void 0 ? void 0 : banner.name) || (banner === null || banner === void 0 ? void 0 : banner.title),
        living_banner_id: banner === null || banner === void 0 ? void 0 : banner._id,
        ...moduleId && {
            living_module_id: moduleId
        },
        ...bannerLocation && {
            living_banner_location: bannerLocation
        },
        ...venderName && {
            living_vender: venderName
        },
        ...venderId && {
            living_vender_id: venderId
        }
    });
};
// Banner 重複曝光
const sendBannerImpressionRepeated = (param)=>{
    let { banner , moduleId , bannerLocation , venderName , venderId  } = param;
    if (!banner) {
        throw new Error("Banner is empty. Can not send GTM impression data");
    }
    GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
        event: "living_action",
        living_event_name: constants/* BANNER_IMPRESSION_REPEATED */.lY,
        living_banner_name: (banner === null || banner === void 0 ? void 0 : banner.name) || (banner === null || banner === void 0 ? void 0 : banner.title),
        living_banner_id: banner === null || banner === void 0 ? void 0 : banner._id,
        ...moduleId && {
            living_module_id: moduleId
        },
        ...bannerLocation && {
            living_banner_location: bannerLocation
        },
        ...venderName && {
            living_vender: venderName
        },
        ...venderId && {
            living_vender_id: venderId
        }
    });
};

;// CONCATENATED MODULE: ./utils/hooks/useBannerGA.js


const isElementFullyInViewport = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top >= 56 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
// for 輪播類型 Banner
const useBannerGAForCarousel = (param)=>{
    let { bannerData , moduleId , bannerLocation , venderName , venderId , swiper , isRepeated =false , enabled =true  } = param;
    const sentBanners = (0,react.useRef)(new Set());
    const observerRef = (0,react.useRef)(null);
    const lastSentBanner = (0,react.useRef)(null) // 記錄最後發送 GA 的 banner ID
    ;
    const handleImpression = (currentBanner)=>{
        if (!currentBanner) return;
        // 檢查是否為同一個 banner 避免連續重複發送
        if (lastSentBanner.current === currentBanner._id) {
            return;
        }
        if (isRepeated) {
            sendBannerImpressionRepeated({
                banner: currentBanner,
                moduleId,
                bannerLocation,
                venderName,
                venderId
            });
            lastSentBanner.current = currentBanner._id;
        } else if (!sentBanners.current.has(currentBanner._id)) {
            sendBannerImpressionUnique({
                banner: currentBanner,
                moduleId,
                bannerLocation,
                venderName,
                venderId
            });
            sentBanners.current.add(currentBanner._id);
            lastSentBanner.current = currentBanner._id;
        }
    };
    (0,react.useEffect)(()=>{
        if (!enabled || !swiper || !(bannerData === null || bannerData === void 0 ? void 0 : bannerData.length)) return;
        // 建立 IntersectionObserver 以觀測 swiper 容器
        observerRef.current = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // 當 swiper 容器完全進入 viewport 時
                if (entry.isIntersecting && entry.intersectionRatio >= 1) {
                    var _swiper_realIndex;
                    const activeIndex = (_swiper_realIndex = swiper === null || swiper === void 0 ? void 0 : swiper.realIndex) !== null && _swiper_realIndex !== void 0 ? _swiper_realIndex : 0;
                    const currentBanner = bannerData[activeIndex];
                    if (currentBanner) {
                        handleImpression(currentBanner);
                    }
                } else if (entry.intersectionRatio === 0) {
                    // 當容器完全離開 viewport 時重置記錄，允許下次進入時再次觸發
                    lastSentBanner.current = null;
                }
            });
        }, {
            threshold: [
                0,
                1.0
            ],
            rootMargin: "-56px 0px 0px 0px"
        });
        // 開始觀測 swiper 容器
        if (swiper.el) {
            observerRef.current.observe(swiper.el);
        }
        // 處理 swiper 切換事件
        const handleSlideChange = ()=>{
            var _swiper_realIndex;
            const activeIndex = (_swiper_realIndex = swiper === null || swiper === void 0 ? void 0 : swiper.realIndex) !== null && _swiper_realIndex !== void 0 ? _swiper_realIndex : 0;
            const currentBanner = bannerData[activeIndex];
            if (swiper.el && isElementFullyInViewport(swiper.el) && currentBanner) {
                handleImpression(currentBanner);
            }
        };
        // 監聽 swiper 切換事件
        // 輪播效果結束後以及 banner index 改變時皆觸發檢查
        if (swiper) {
            swiper.on("slideChangeTransitionEnd", handleSlideChange);
            swiper.on("realIndexChange", handleSlideChange);
        }
        return ()=>{
            // 清理 observer
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
            // 清理 swiper 事件監聽
            if (swiper) {
                swiper.off("slideChangeTransitionEnd", handleSlideChange);
                swiper.off("realIndexChange", handleSlideChange);
            }
        };
    }, [
        swiper,
        bannerData,
        isRepeated,
        moduleId,
        bannerLocation,
        venderName,
        venderId,
        enabled
    ]);
    // 初始化完成時若在 viewport 內則馬上紀錄
    (0,react.useEffect)(()=>{
        if (enabled && swiper && swiper.initialized && (bannerData === null || bannerData === void 0 ? void 0 : bannerData.length) > 0) {
            if (swiper.el && isElementFullyInViewport(swiper.el)) {
                var _swiper_realIndex;
                const activeIndex = (_swiper_realIndex = swiper === null || swiper === void 0 ? void 0 : swiper.realIndex) !== null && _swiper_realIndex !== void 0 ? _swiper_realIndex : 0;
                const currentBanner = bannerData[activeIndex];
                if (currentBanner) {
                    handleImpression(currentBanner);
                }
            }
        }
    }, [
        enabled,
        swiper === null || swiper === void 0 ? void 0 : swiper.initialized,
        bannerData
    ]);
};
// for 非輪播類型 Banner
const useBannerGAForNonCarousel = (param)=>{
    let { bannerData , moduleId , bannerLocation , isRepeated =false  } = param;
    const sentBanners = (0,react.useRef)(new Set());
    const inViewportState = (0,react.useRef)(new Map());
    const observerRef = (0,react.useRef)(null);
    const handleImpression = (banner)=>{
        if (!(banner === null || banner === void 0 ? void 0 : banner._id)) return;
        if (isRepeated) {
            if (!inViewportState.current.get(banner._id)) {
                sendBannerImpressionRepeated({
                    banner: banner,
                    moduleId,
                    bannerLocation
                });
                inViewportState.current.set(banner._id, true);
            }
        } else if (!sentBanners.current.has(banner._id)) {
            sendBannerImpressionUnique({
                banner: banner,
                moduleId,
                bannerLocation
            });
            sentBanners.current.add(banner._id);
        }
    };
    (0,react.useEffect)(()=>{
        const banner = bannerData === null || bannerData === void 0 ? void 0 : bannerData[0];
        if (!(banner === null || banner === void 0 ? void 0 : banner._id)) return;
        // 建立 IntersectionObserver 以觀測 banner
        observerRef.current = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const bannerId = entry.target.getAttribute("data-banner-id");
                // 當 banner 完全進入 viewport 時
                if (entry.isIntersecting && entry.intersectionRatio >= 1) {
                    const targetBanner = bannerData.find((b)=>b._id === bannerId) || banner;
                    if (targetBanner) {
                        handleImpression(targetBanner);
                    }
                } else if (entry.intersectionRatio === 0) {
                    // 當 banner 完全離開 viewport 時，重置該 banner 在 viewport 的狀態
                    if (bannerId && isRepeated) {
                        inViewportState.current.set(bannerId, false);
                    }
                }
            });
        }, {
            threshold: [
                0,
                1.0
            ],
            rootMargin: "-56px 0px 0px 0px"
        });
        // 開始觀察所有具有 data-banner-id 屬性的元素
        const bannerElements = document.querySelectorAll("[data-banner-id]");
        bannerElements.forEach((element)=>{
            const bannerId = element.getAttribute("data-banner-id");
            // 只觀察當前 bannerData 中包含的 banner
            if (bannerData.some((b)=>b._id === bannerId)) {
                observerRef.current.observe(element);
            }
        });
        return ()=>{
            // 清理 observer
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };
    }, [
        bannerData,
        isRepeated,
        moduleId,
        bannerLocation
    ]);
};


/***/ })

}]);